module.exports = __webpack_public_path__ + "static/media/ico_phone-phone.d8084e71.svg";